import adminRoutes from './adminRoutes';
import mailRoutes from './mailRoutes';
import authRoutes from './authRoutes';
import performanceRoutes from './performanceRoutes';
import allRoutes from './routesOnNav';
import acgRoutes from './acgRoutes';

const topLevelRoutes = [
  {
    title: 'Performance',
    fullTitle: 'Performance',
    icon: 'equalizer',
    path: '/performance',
  },
  {
    title: 'Mail',
    fullTitle: 'Mail',
    icon: 'mail_outline',
    path: '/mail',
  },
];

export {
  adminRoutes,
  mailRoutes,
  authRoutes,
  performanceRoutes,
  topLevelRoutes,
  allRoutes,
  acgRoutes,
};
